import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import './App.scss';
import Layout from './SharedModule/Layout/layout';

function App() {
  return (
    <>
    <Router>
      <Layout/>
    </Router>
    </>
  );
}

export default App;
